import React, { useEffect } from "react";
import { ADVERTISER } from "../../../core/theme/reportTheme";

// A panel over the page (the advertiser picker, Link a map pack listing).
// Esc, ✕ or a click outside closes it. wide: a wider box for bigger tables.
export default function Modal({ onClose, wide, children }) {
  useEffect(() => {
    const onKey = e => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <>
      <div className={ADVERTISER.modalBackdrop} onClick={onClose} />
      <div className={wide ? ADVERTISER.modalWide : ADVERTISER.modal} role="dialog">{children}</div>
    </>
  );
}
